import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Plus, Workflow } from 'lucide-react';
import Button from '@/components/primitives/Button.jsx';
import EmptyState from '@/components/patterns/EmptyState.jsx';
import PageHeader from '@/components/patterns/PageHeader.jsx';
import Tabs from '@/components/patterns/Tabs.jsx';
import { automationListItems } from '@/redux/selectors/pieveSelectors/automationCatalogSelectors.js';
import AUTOMATION_KINDS from '../lib/AUTOMATION_KINDS.js';
import AskPieveDialog from '../components/AskPieveDialog.jsx';
import AutomationRow from '../components/AutomationRow.jsx';

const FILTERS = [{ value: 'all', label: 'All' }, ...Object.values(AUTOMATION_KINDS).map((kind) => ({ value: kind.kind, label: kind.plural }))];

/** Every automation of the organization, filterable by kind, with the way to ask Pieve for a new one. */
const AutomationListPage = () => {
  const items = useSelector(automationListItems);
  const [filter, setFilter] = useState('all');
  const [asking, setAsking] = useState(false);
  const askButton = (
    <Button variant="primary" iconStart={Plus} onClick={() => setAsking(true)}>
      New automation
    </Button>
  );

  const renderList = (value) => {
    const visible = value === 'all' ? items : items.filter((item) => item.kind === value);

    if (visible.length === 0) {
      return <EmptyState icon={Workflow} title={value === 'all' ? 'No automations yet' : `No ${AUTOMATION_KINDS[value].plural.toLowerCase()} yet`} description="Describe the outcome and Pieve sets it up, for example: every Monday, send me the deals that closed last week." action={askButton} />;
    }

    return (
      <ul className="automations-list" aria-label="Automations">
        {visible.map((item) => (
          <AutomationRow key={`${item.kind}-${item.id}`} automation={item} />
        ))}
      </ul>
    );
  };

  return (
    <div className="comp-page">
      <PageHeader title="Automations" description="Work that keeps running without you: on a schedule, or when something happens in one of your apps." actions={items.length > 0 ? askButton : null} />
      <Tabs label="Show" value={filter} onValueChange={setFilter} items={FILTERS.map((option) => ({ ...option, panel: renderList(option.value) }))} />
      <AskPieveDialog open={asking} onOpenChange={setAsking} />
    </div>
  );
};

export default AutomationListPage;
